import React from 'react';

import AnnualReportThemeHero from '../../../../components/AnnualReportThemeHero';

const AnnualReportThemeTeaser = ({ entity }) => {
  const colorVariant = entity.getIn(['field_color_variant', 0, 'value'], '');

  return (
    <article className={`AnnualReportTheme AnnualReportTheme--${colorVariant}`}>

      <AnnualReportThemeHero
        entity={entity}
        withLink
      />

    </article>
  );
};

export default AnnualReportThemeTeaser;
